<template>
  <div id="parceiros">
      <div class="produtos-titulo">
            <h2>Parceiros</h2>
        </div>
      <div class="row container-colchoes">
          
          <div class="col-md-3 card-parceiro">
              <img width="200px" class="logo-parceiro" src="@/assets/parceiro2.png" alt="">
          </div>
          <div class="col-md-3 card-parceiro">
              <img width="200px" class="logo-parceiro" src="@/assets/parceiro3.jpg" alt="">
          </div> 
          <div class="col-md-3 card-parceiro">
              <img width="200px" class="logo-parceiro" src="@/assets/parceiro4.png" alt="">
          </div>
          <div class="col-md-3 card-parceiro">
              <img width="100px" class="logo-parceiro" src="@/assets/parceiro1.jpeg" alt="">
          </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

#parceiros {
    margin-top: 20px;
    margin-bottom: 20px;
    background: white;
}
.card-parceiro{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
    height: 100px;
}


</style>